var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sideBar",staticClass:"sideBar filterLetter otherXS"},_vm._l((_vm.sidebarCategories),function(category,index){return _c('span',{key:index + category.letter,on:{"click":function($event){return _vm.activateSidebar(category)}}},[_c('a',{class:{ inActive: !category.active }},[_vm._v(_vm._s(category.letter))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }